export enum AppEnv {
  LOCAL = 'local',
  DEV = 'dev',
  STG = 'stg',
  PROD = 'prod',
}

export type EnvProps = {
  appEnv: AppEnv;
  oidc: {
    issuer: string;
    clientId: string;
    redirectUri?: string;
    scopes?: string[];
    pkce?: boolean;
  };
  piaApiBaseUrl: string;
};

declare global {
  interface Window {
    MLBBest: {
      env: EnvProps;
    };
  }
}
